// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b0d5354c","952":"43f680ae"}[chunkId] + ".chunk.js";
};